function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux'; // code splitting and lazy loading
// https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
// const Footer = React.lazy(() => import("./Footer"));
// loading

const loading = () => /*#__PURE__*/React.createElement("div", {
  className: "text-center"
});

class DefaultLayout extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "componentDidMount", () => {
      if (document.body) document.body.classList.add('authentication-bg');
    });

    _defineProperty(this, "componentWillUnmount", () => {
      if (document.body) document.body.classList.remove('authentication-bg');
    });
  }

  render() {
    const children = this.props.children || null;
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: loading()
    }, children);
  }

}

export default connect()(DefaultLayout);